import { render, staticRenderFns } from "./meritDetails.vue?vue&type=template&id=6ff42100&"
import script from "./meritDetails.vue?vue&type=script&lang=js&"
export * from "./meritDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports